import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

const BuyLicense = lazy(() => import("../Pages/BuyLicense"));
const Dashboard = lazy(() => import("../Home/Dashboard"));
const Consulting = lazy(() => import("../Pages/Consulting"));
const Training = lazy(() => import("../Pages/Training"));
const Contact = lazy(() => import("../Pages/Contant"));

const Introduction = lazy(() => import("../Blog/TutorialArticles/Introduction"));
const Nxopenprogramming = lazy(() => import("../Blog/TutorialArticles/Nxopenprogramming"));
const NXuicustomization = lazy(() => import("../Blog/TutorialArticles/NXuicustomization"));
const PartAssembly = lazy(() => import("../Blog/TutorialArticles/PartAssembly"));

const GenerationandPMI = lazy(() => import("../Blog/ProjectUsecase/GenerationandPMI"));
const PartandAssemblyAutomation = lazy(() => import("../Blog/ProjectUsecase/PartandAssemblyAutomation"));
const PDFexportautomation = lazy(() => import("../Blog/ProjectUsecase/PDFexportautomation"));
const TeamcenterIntegration = lazy(() => import("../Blog/ProjectUsecase/TeamcenterIntegration"));

const NXopenvscreo = lazy(() => import("../Blog/Comparsion/NXopenvscreo"));
const Solidworksapi = lazy(() => import("../Blog/Comparsion/Solidworksapi"));
const Catiacaa = lazy(() => import("../Blog/Comparsion/Catiacaa"));
const Nxopenpython = lazy(() => import("../Blog/Comparsion/Nxopenpython"));

const ContactButton = lazy(() => import("../Home/ContactButton"));



function AppRoutes() {
  return (
    <BrowserRouter>
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/training" element={<Training />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Introduction to NX Open" element={<Introduction />} />
        <Route path="/NX Open Programming Fundamentals" element={<Nxopenprogramming />} />
        <Route path="/NX UI Customization & User Interfaces" element={<NXuicustomization />} />
        <Route path="/Part, Assembly & Drawing Automation" element={<PartAssembly />} />
        <Route path="/Drawing Generation & PMI Extraction" element={<GenerationandPMI />} />
        <Route path="/Part & Assembly Automation" element={<PartandAssemblyAutomation />} />
        <Route path="/PDF/DXF Export Automation" element={<PDFexportautomation />} />
        <Route path="/TeamCenter Integration" element={<TeamcenterIntegration />} />
        <Route path="/NX Open vs Creo Toolkit" element={<NXopenvscreo />} />
        <Route path="/NX Open vs SOLIDWORKS API" element={<Solidworksapi />} />
        <Route path="/NX Open vs CATIA CAA" element={<Catiacaa   />} />
        <Route path="/NX Open C++ vs NX Open Python" element={<Nxopenpython />} />
         <Route path="/Buy-License" element={<BuyLicense />} />


      </Routes>
      <ContactButton/>
      </Suspense>
    </BrowserRouter>
  );
}

export default AppRoutes;